import React from 'react'
import { Button } from 'react-bootstrap'
import styles from './IconButton.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IIconButton {
  icon: any
  className?: string
  disabled?: boolean
  onClick: any
}

const IconButton: React.FC<IIconButton> = ({ icon, className = '', onClick, disabled = false }) => {
  return (
    <Button disabled={disabled} className={`${styles.iconButton} ${className}`} onClick={onClick}>
      <FontAwesomeIcon icon={icon} />
    </Button>
  )
}

export default IconButton
